import React, { Fragment, useEffect, useState, useContext } from 'react'
import { Link, withRouter } from 'react-router-dom'
import styled, { css } from 'styled-components';
import { Context } from '../context';
import { getMetadataCategories, getDataById } from './utils';
import { ContentInfoLine } from './ContentInfo';
import uniqid from "uniqid";
import { UIinput } from '../uikit/UIinput';
import { UIemojiSelect } from '../uikit/UIemojiSelect';
import { UIbutton } from '../uikit/Uikit';
import './gs_add.css';
import { UItoggle } from '../uikit/UItoggle';
import { UIradio } from '../uikit/UIradio';


export function MetadataFilters({ videoId }) {
  const context = useContext(Context);

  const [query, setQuery] = useState('');


  const [filters, setFilters] = useState(['mine', 'others',])


  return (
    <>

      <div className="l_content_info_section">

        <div className="l_info_line">
          <div className="flex middle">
            <div className="l_video_info_title">
              Metadata filters
            </div>
            <div
              className="x_meta_actions"
            >
              <UIbutton sm xs flat>Reset</UIbutton>
            </div>
          </div>
        </div>






        <div className="l_pop_content">

          <div className="l_info_line">

            <UIradio options={[
              {
                title: 'Show all',
                value: 'onlyAll',
              },
              {
                title: 'Show only my tags',
                value: 'onlyMine',
              },
              {
                title: 'Only highlights',
                value: 'onlyMine',
              },
            ]}
            />


          </div>
        </div>







      </div>





    </>
  )
}